import styled from "@mui/styled-engine-sc";
// import { palette } from "../../../themes/color-palette";

export const StyledInputStore = styled("div")`
  ${({ theme }) => `
    .autocomplete-listbox {
      margin: 0 ${theme.spacing(1)};
      padding: ${theme.spacing(1)} 0;

      li {
        font-weight: 400;
        min-height: auto;
        padding: ${theme.spacing(2)} ${theme.spacing(3)} ${theme.spacing(2)} ${theme.spacing(3)};
        background:  ${theme.palette.white.main};
        border-radius: 4px;

        &.MuiAutocomplete-option.Mui-focused {
          font-weight: 700;
          background: ${theme.palette.secondary.extraLight};
          cursor: pointer;
        }

        /* &.MuiMenuItem-root.Mui-selected {
          font-weight: 700;
          cursor: default;
        } */


      }
    }

  `}
`;
